import React from 'react';
import { Tag, Space, Tooltip, Button } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const AppliedFiltersDisplay = ({
  appliedValues = {},
  metricsOptions = [],
  adTypeOptions = [],
  childCountryOptions = [],
  networkOptions = []
}) => {
  
  const extractTextFromReactElement = (element) => {
    if (typeof element === 'string') {
      return element;
    }
    if (typeof element === 'number') {
      return String(element);
    }
    if (!element || typeof element !== 'object') {
      return '';
    }
    
    
    if (element.props && element.props.children) {
      const children = element.props.children;
      if (typeof children === 'string') {
        return children;
      }
      if (Array.isArray(children)) {
        return children.map(child => extractTextFromReactElement(child)).join(' ').trim();
      }
      return extractTextFromReactElement(children);
    }
    
    return '';
  };
  const getDisplayValue = (value, options) => {
    if (!value) return '';
    
    
    
    if (Array.isArray(value)) {
      if (value.length === 0) return '';
      return value.map(v => {
        
        if (typeof v === 'object' && v !== null) {
          
          if (v.label && typeof v.label === 'string') return v.label;
          if (v.name && typeof v.name === 'string') return v.name;
          if (v.value && typeof v.value === 'string') return v.value;
          
          return JSON.stringify(v);
        }
        const option = options.find(opt => opt.value === v);
        if (option) {
          
          if (typeof option.label === 'string') {
            return option.label;
          }
          
          const extractedText = extractTextFromReactElement(option.label);
          if (extractedText) {
            return extractedText;
          }
          
          return option.value || String(v);
        }
        return String(v);
      }).join(', ');
    }
    
    
    if (typeof value === 'object' && value !== null) {
      if (value.label && typeof value.label === 'string') return value.label;
      if (value.name && typeof value.name === 'string') return value.name;
      if (value.value && typeof value.value === 'string') return value.value;
      return JSON.stringify(value);
    }
    
    
    const option = options.find(opt => opt.value === value);
    if (option) {
      
      if (typeof option.label === 'string') {
        return option.label;
      }
      
      const extractedText = extractTextFromReactElement(option.label);
      if (extractedText) {
        return extractedText;
      }
      
      return option.value || String(value);
    }
    return String(value);
  };

  const hasAnyFilter = () => {
    
    return (
      appliedValues.metrics ||
      appliedValues.adType ||
      (appliedValues.countries && appliedValues.countries.length > 0) ||
      (appliedValues.networks && appliedValues.networks.length > 0)
    );
  };

  if (!hasAnyFilter()) {
    return null;
  }

  const renderFilterTag = (label, value, options) => {
    const displayValue = getDisplayValue(value, options);
    if (!displayValue) return null;

    return (
      <Tag
        style={{ 
          margin: '2px 4px',
          borderRadius: '12px',
          background: '#f0f2f5',
          border: '1px solid #d9d9d9',
          fontSize: '12px',
          padding: '2px 8px'
        }}
      >
        <strong>{label}:</strong> {displayValue}
      </Tag>
    );
  };

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      flexWrap: 'wrap',
      gap: '4px',
      maxWidth: '100%',
      overflow: 'hidden'
    }}>
      <Tooltip title="filter">
        <Button type="dashed" shape="circle" size='small' icon={<FilterOutlined style={{ 
        color: '#1890ff', 
        fontSize: '12px',
        flexShrink: 0
      }} />} />
      </Tooltip>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        flexWrap: 'wrap',
        gap: '4px',
        minWidth: 0,
        flex: 1
      }}>
        {renderFilterTag(
          'Metrics', 
          appliedValues.metrics, 
          metricsOptions
        )}
        
        {(appliedValues.metrics === 'imp_dau' || appliedValues.metrics === 'ecpm') && renderFilterTag(
          'Ad Type', 
          appliedValues.adType, 
          adTypeOptions
        )}
        
        {renderFilterTag(
          'Countries', 
          appliedValues.countries, 
          childCountryOptions
        )}
        
        {renderFilterTag(
          'Networks', 
          appliedValues.networks, 
          networkOptions
        )}
      </div>
    </div>
  );
};

export default AppliedFiltersDisplay;
